import "./LaunchOfferCard.css";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { trackWhatsAppConversion } from "../utils/googleAds";


const LaunchOfferCard = () => {
  
  const handleLaunchOffer = () => {
    trackWhatsAppConversion();
    
  const phoneNumber = "919653304639";

  const message =
    "Hi, I'm interested in your ₹22,999 Website Launch Offer. I'd like to know more about the package and get started.";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  window.open(whatsappUrl, "_blank");
};
  
    return (
    <div className="launch-offer-card">

      <div className="launch-left">

        <div className="launch-top">

          <span className="launch-badge">
            🚀 Launch Offer
          </span>

          <span className="time-badge">
            Limited Time
          </span>

        </div>

        <h2 className="launch-title">
          Websites from <span>₹22,999</span>
        </h2>

        <h3 className="launch-bonus-title">
          Get FREE Bonuses Worth ₹18,000
        </h3>

        <ul className="launch-list">

          <li>
            <CheckCircle2 size={20} />
            <span>Free UI/UX Consultation — ₹5,000 value</span>
          </li>

          <li>
            <CheckCircle2 size={20} />
            <span>Free Domain + Hosting Setup — ₹3,000 value</span>
          </li>

          <li>
            <CheckCircle2 size={20} />
            <span>30 Days Premium Support — ₹10,000 value</span>
          </li>

        </ul>

        <button
  className="launch-button"
  onClick={handleLaunchOffer}
>
  Claim Launch Offer
  <ArrowRight size={20} />
</button>

      </div>

      <div className="launch-right">

        <div className="right-overlay"></div>

        <div className="glow"></div>

        <div className="ellipse"></div>

        <div className="plus plus1">+</div>
        <div className="plus plus2">+</div>
        <div className="plus plus3">+</div>
        <div className="plus plus4">+</div>

      </div>

    </div>
  );
};

export default LaunchOfferCard;